export interface Permission {
  panel: string;
  can_read: boolean;
  can_create: boolean;
  can_update: boolean;
  can_delete: boolean;
  allowed_document_types: string[] | null;
}

/** Mirrors the backend's `alpha_dash|min:3|max:50` username rule (no "@", so it can never be mistaken for an email at login). */
export const USERNAME_PATTERN = /^[\p{L}\p{M}\p{N}_-]{3,50}$/u;
export const USERNAME_PATTERN_MESSAGE = 'Entre 3 y 50 caracteres: letras, números, "-" o "_"';

export class User {
  id: number = 0;
  name: string = '';
  username: string | null = null;
  email: string = '';
  role: string = '';
  role_id: number = 0;
  company_id: number = 0;
  token: string = '';
  permissions: Permission[] | null = null;
}
